<script setup>
import config from '@/common/config'
import { closest, degToRad, equals, get, isImgFile, openWin, post, postMultipart, qsel, qsela, strToXml, syncScroll, xmlToStr, ymd } from '@/common/util'
import { Feature, Map, View } from 'ol'
import { onBeforeUnmount } from 'vue'
import { reactive } from 'vue'
import { onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import {defaults as defaultControls} from 'ol/control/defaults.js'
import TileLayer from 'ol/layer/Tile'
import { OSM, XYZ } from 'ol/source'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import { fromLonLat } from 'ol/proj'
import { Icon, Style } from 'ol/style'
import { Point } from 'ol/geom'
import { useMetaStore } from '@/stores'
import _ from 'lodash-es'
import krpanoxmls from '@/common/krpanoxmls'
import { bearing } from '@turf/turf'
const props = defineProps({
  svid: String,
  fid: String,
  initmode: String,
  hlookat: Number,
  vlookat: Number,
  reload: Function
})
const krpanocontainer=ref(null),resizehandle=ref(null),popcard = ref(null),route=useRoute(),metaStore=useMetaStore()
const meta=reactive({panos:[],features:[],showpop:true,selpoptype:'map',memosearchval:'',hlookat:0,vlookat:0,minimapzoom:12,bgmaps:['GOOGLE-BASE','GOOGLE-SATELLITE','OSM'],selbgm:'GOOGLE-BASE'})
,clickPopBtn=(type)=>{
  meta.selpoptype=type
  searchMemo(1)
  const onadd=type=='takenotes'
  meta.krpano.subkrpano1.set("hotspot[mousespot].visible",onadd)
  if(meta.krpano.subkrpano2)meta.krpano.subkrpano2.set("hotspot[mousespot].visible",onadd)
  // if(meta.panos.length>1){
  //   meta.krpano.set('layer[krpano1container].enabled', onadd)
  //   meta.krpano.set('layer[krpano2container].enabled', onadd)
  //   meta.krpano.set('layer[ui].visible',!onadd)
  //   if(onadd)meta.krpano.call('left_only(tween)')
  //   else meta.krpano.call('split_screen(tween,0.5)')
  // }
},vwapi=async(method='get',data,callback=()=>{})=>{
  const url='rest/authed/member/vwapi'
  if (data instanceof Function){
    callback=data
    data=null
  }
  if(method=='get')return await get(url,callback,data)
  return await post(url,data,callback)
},searchMemo=async(page=1)=>{
  const pm={where:{ttl_or_:meta.memosearchval,featureid_eq_:meta.fid},page:page,size:5,sortcol:'mdt',isasc:false}
  pm.where.cont_or_=pm.where.ttl_or_
  const res=await post('rest/authed/member/searchmemo',pm)
  meta.memos=res.data.rows
  let krpanos=[meta.krpano]
  if(meta.panos.length>1)krpanos=[meta.krpano.get('subkrpano1'),meta.krpano.get('subkrpano2')]
  for (let i = 0; i < 2; i++)krpanos.forEach(subkrpano=>subkrpano.get("hotspot").getArray().forEach(hs=>{
    if(hs.name&&hs.name.startsWith('memo_'))subkrpano.removehotspot(hs.name)
  }))
  meta.selmemoid=null
  meta.memos.forEach(memo=>krpanos.forEach((subkrpano)=>{
    const spot=subkrpano.addhotspot('memo_'+memo.id+'_'+subkrpano.name)
    spot.ath=memo.ath
    spot.atv=memo.atv
    spot.subkrpano=subkrpano
    spot.url=config.frontRoot+'noteicon.png'
    const idx=subkrpano.name.replace('subkrpano','')
    spot.onover="jscall(krpano.pakrpano.call('toggle_layer("+idx+",true)'))"
    spot.onout="jscall(krpano.pakrpano.call('toggle_layer("+idx+",false)'))"
    spot.onclick=caller=>{
      meta.krpano.call(`lookto(${caller.ath},${caller.atv});`)
      meta.ath=caller.ath
      meta.atv=caller.atv
      memoPop(caller.name.replace('_'+caller.subkrpano.name,'')+'_detail',async dspot=>{
        const mid=dspot.name.replace('memo_','').split('_detail')[0]
        meta.selmemoid=mid
        const files=await post(`rest/authed/member/attachedfiles`,{tartbl:'Memo',refids:[mid]})
        if(files.data.length){
          const img=qsel(`.${dspot.name} .memoimg`)
          img.src=config.backend+'attachedfile/'+files.data[0].id
          img.parentElement.classList.remove('d-none')
          qsel(`.${dspot.name} .memoimgdel`).onclick=()=>delMemoImg(dspot.name,mid)
        }
        const dm=meta.memos.find(item=>item.id==mid)
        const ttlel=qsel(`.${dspot.name} .memottl`)
        ttlel.value=dm.ttl
        ttlel.onchange=evt=>qsela(`.memottl`).forEach(el=>el.value=evt.target.value)
        const contel=qsel(`.${dspot.name} .memocont`)
        contel.onchange=evt=>qsela(`.memocont`).forEach(el=>el.value=evt.target.value)
        contel.value=dm.cont
        const dbtn=qsel(`.${dspot.name} .memodel`)
        dbtn.setAttribute('mid',mid)
        dbtn.onclick=evt=>{
          if(confirm(metaStore.t('del_con')))delMemo(closest(evt.target,'button').getAttribute('mid'))
        }
      })
    }
  }))
},delMemoImg=async(dspot,id)=>{
  if(id){
    if(!confirm(metaStore.t('del_con')))return
    metaStore.blockLoading()
    const res=await post('rest/authed/member/delmemoimg',{id:id})
    metaStore.blockLoading(false)
    metaStore.toastRslt(res,false)
  }
  qsel(`.${dspot} .memoimgwrap`).classList.add('d-none')
},delMemo=async(id)=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/member/delmemo',{id:id})
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,false)
  searchMemo(1)
},saveMemo=async()=>{
  const memo={addr:meta.addr,zipcode:meta.zipcode,addrtype:meta.addrtype,featureid:meta.fid}
  if(meta.selmemoid){
    memo.id=meta.selmemoid
    memo.createrid=meta.memos.find(smemo=>smemo.id==memo.id).createrid
  }
  memo.ath=meta.ath
  memo.atv=meta.atv
  const clsnm1=meta.memopopname+'_subkrpano1'
  const clsnm2=meta.memopopname+'_subkrpano2'
  memo.ttl=qsel(`.${clsnm1} .memottl`).value
  memo.cont=qsel(`.${clsnm1} .memocont`).value
  memo.xpos=qsel(`.${clsnm1} .memox`).value
  memo.ypos=qsel(`.${clsnm1} .memoy`).value
  memo.svid=props.svid
  let upfile1=qsel(`.${clsnm1} .upfile`)
  let upfile2=qsel(`.${clsnm2} .upfile`)
  const img=qsel(`.${clsnm1} .memoimg`)
  if(!img.classList.contains('d-none')){
    if(upfile1.files&&upfile1.files.length)memo.file=upfile1.files[0]
    if(!memo.file&&upfile2?.files&&upfile2?.files?.length)memo.file=upfile2.files[0]
  }
  if(_.isEmpty(memo.ttl))return metaStore.toastKey('enteratitleupto50characters',false)
  if(!confirm(metaStore.t('save_con')))return
  metaStore.blockLoading()
  const res=await postMultipart('rest/authed/member/savememo',memo)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  meta.selmemoid=res.data.id
  searchMemo(1)
},memoDetailPop=(id)=>{
  meta.selmemoid=id
  const spot=meta.krpano.subkrpano1.get(`hotspot[memo_${id}_subkrpano1]`)
  spot.onclick(spot)
},memoPop=(name,ready=()=>{})=>{
  meta.memopopname=name
  let krpanos=[meta.krpano]
  if(meta.panos.length>1)krpanos=[meta.krpano.get('subkrpano1'),meta.krpano.get('subkrpano2')]
  krpanos.forEach(krpano=>{
    const cnm=name+'_'+krpano.name
    if(krpano.get(`hotspot[${cnm}]`))krpano.removehotspot(cnm)
    const spot=krpano.addhotspot(cnm)
    spot.ath=meta.ath
    spot.atv=meta.atv
    spot.edge='lefttop'
    spot.type='html'
    spot.width=300
    spot.height=550
    spot.left=0
    spot.top=0
    spot.zorder=10
    const cont=qsel('.memowrap').innerHTML
    spot.html=cont
    spot.onloaded=caller=>{
      caller.htmlelement.classList.add(caller.name)
      const othernm=caller.name.includes('_subkrpano1')?caller.name.replace('_subkrpano1','_subkrpano2'):caller.name.replace('_subkrpano2','_subkrpano1')
      const otherdv=qsel('.'+othernm)
      if(otherdv){
        caller.htmlelement.addEventListener('scroll', () => syncScroll(caller.htmlelement, otherdv));
        otherdv.addEventListener('scroll', () => syncScroll(otherdv,caller.htmlelement));
      }
      qsel(`.${caller.name} .memox`).value=meta.pos[0].toFixed(5)
      qsel(`.${caller.name} .memoy`).value=meta.pos[1].toFixed(5)
      qsel(`.${caller.name} .memoaddr`).value=meta.addr
      const cbtn=qsel(`.${caller.name} .memocancel`)
      cbtn.setAttribute('spotnm',caller.name)
      cbtn.onclick=evt=>{
        const spotnm=closest(evt.target,'button').getAttribute('spotnm')
        const prefix=spotnm.split('_subkrpano')[0]
        meta.krpano.subkrpano1.removehotspot(prefix+'_subkrpano1')
        if(meta.panos.length>1)meta.krpano.subkrpano2.removehotspot(prefix+'_subkrpano2')
      }
      qsel(`.${caller.name} .memosave`).onclick=saveMemo
      qsel(`.${caller.name} .memottl`).onkeyup=evt=>qsela(`.memottl`).forEach(el=>el.value=evt.target.value)
      qsel(`.${caller.name} .memocont`).onkeyup=evt=>qsela(`.memocont`).forEach(el=>el.value=evt.target.value)
      const upfile=qsel(`.${caller.name} .upfile`)
      upfile.setAttribute('spotnm',caller.name)
      upfile.onchange=evt=>{
        const spotnm=evt.target.getAttribute('spotnm')
        const otherspotnm=spotnm.includes('_subkrpano1')?spotnm.replace('_subkrpano1','_subkrpano2'):spotnm.replace('_subkrpano2','_subkrpano1')
        const img=qsel(`.${spotnm} .memoimg`)
        const otherimg=qsel(`.${otherspotnm} .memoimg`)
        const delimg=dievt=>{
          try{
            qsel(`.${spotnm} .upfile`).value=null
            qsel(`.${spotnm} .memoimgwrap`).classList.add('d-none')
          }catch(e){}
          try{
            qsel(`.${otherspotnm} .upfile`).value=null
            qsel(`.${otherspotnm} .memoimgwrap`).classList.add('d-none')
          }catch(e){}
        }
        try{
          qsel(`.${spotnm} .memoimgdel`).onclick=delimg
          qsel(`.${otherspotnm} .memoimgdel`).onclick=delimg
        }catch(e){}
        if(evt.target.files.length&&isImgFile(evt.target.files[0].name)){
          img.src=window.URL.createObjectURL(evt.target.files[0])
          img.parentElement.classList.remove('d-none')
          try{
            otherimg.src=window.URL.createObjectURL(evt.target.files[0])
            otherimg.parentElement.classList.remove('d-none')
        }catch(e){}
        }else{
          img.parentElement.classList.add('d-none')
          otherimg.parentElement.classList.add('d-none')
        }
      }
      if(caller.name.includes('memo_new'))qsel(`.${caller.name} .memodel`).parentElement.remove()
      ready(caller)
    }
  })
},panoClick=()=>{
  if(meta.selpoptype=='takenotes')clickAddMemo()
},clickAddMemo=()=>{
  meta.krpano.call("screentosphere(mouse.x, mouse.y, mouseath, mouseatv);")
  meta.ath = parseFloat(meta.krpano.get("mouseath"))
  meta.atv = parseFloat(meta.krpano.get("mouseatv"))
  memoPop('memo_new')
},initKrpano=()=>{
  const script = document.createElement('script')
  script.src = config.backend+'krpano/krpano.js'
  script.onload = () => {
    if (window.embedpano) {
      window.embedpano({target:'krpanocontainer',html5:'only',onready:krpano=>{
        let searchParams=new URL(location.href).searchParams
        if(searchParams.has('log')&&searchParams.get('log'))krpano.call("showlog(true)");
        krpano.subkrpano1=krpano
        meta.krpano=krpano
        // krpano.events.addListener('onxmlcomplete',()=>{
        // },'once')
        krpano.actions.loadxml(meta.panoxml)
        if(meta.panos.length==0)return
        if(meta.panos.length==1)meta.krpano.set('name','subkrpano1')
        krpano.addChangeListener('view.hlookat',()=>{
          let ang=krpano.get("view.hlookat")
          meta.hlookat=ang
          ang= ang * Math.PI / 180
          const style= meta.markerlayer.getStyle().clone()
          style.getImage().setRotation(ang+meta.baserad)
          meta.markerlayer.setStyle(style)
        })
        krpano.addChangeListener('view.vlookat',()=>{
          let ang=krpano.get("view.vlookat")
          meta.vlookat=ang
        })
        searchMemo()
        if(meta.initmode)krpano.call(meta.initmode+'(set)')
        krpano.call(`lookat(${meta.hlookat},${meta.vlookat})`);
      }})
    } else {
      console.error('krpano 로딩 실패')
    }
  }
  document.body.appendChild(script)
},wfs1=async ({fids,layernm,filter})=>{
  const wfsParams = {SERVICE:'WFS',VERSION:'1.0.0',REQUEST:'GetFeature',TYPENAME:layernm,OUTPUTFORMAT:'application/json'}
  if(filter)wfsParams.FILTER=filter
  else if(fids?.length)wfsParams.FEATUREID=fids.toString()
  const wres=await get('wfs',()=>{},wfsParams)
  return wres
},wfs=async({ fids, layernm, filter })=>{
  const url = config.backend + 'wfs';
  let filterXml = '';
  if (filter) {
      filterXml = filter;
  } else if (fids?.length) {
      filterXml = `<ogc:Filter><ogc:FeatureId fid="${fids.join(',')}"/></ogc:Filter>`;
  }
  const postBody = `<wfs:GetFeature service="WFS" version="1.0.0"
          outputFormat="application/json"
          xmlns:wfs="http://www.opengis.net/wfs"
          xmlns:ogc="http://www.opengis.net/ogc"
          xmlns:gml="http://www.opengis.net/gml">
          <wfs:Query typeName="${layernm}">
              ${filterXml}
          </wfs:Query>
      </wfs:GetFeature>`

  try {
      const response = await fetch(url, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/xml',
          },
          body: postBody
      });
      if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
      }
      return await response.json();
  } catch (e) {
      console.error("WFS 호출 중 오류 발생:", e);
      return null;
  }
},init=async ()=>{
  meta.sv=await get('rest/authed/member/sv/'+props.svid)
  meta.sv=meta.sv.data
  let res=await get('rest/authed/member/panos/'+meta.fid)
  let filter='<Filter><PropertyIsEqualTo><PropertyName>featureid</PropertyName><Literal>'+meta.fid+'</Literal></PropertyIsEqualTo></Filter>'
  const wres=await wfs({layernm:meta.sv.gspointnm,filter})
  meta.feature=wres.features.map(fea=>({id:fea.id,...fea.properties}))[0]
  let pos=[meta.feature.xpos,meta.feature.ypos]
  meta.merges=[]
  if(meta.feature.mergefid&&meta.feature.mergefid!=meta.feature.featureid)return window.tourl(meta.feature.mergefid)
  if(meta.feature.mergefid){
    filter='<Filter><PropertyIsEqualTo><PropertyName>mergefid</PropertyName><Literal>'+meta.feature.mergefid+'</Literal></PropertyIsEqualTo></Filter>'
    const res=await wfs({layernm:meta.sv.gspointnm,filter:filter})
    meta.merges=res.features.filter(fea=>fea.featureid!=meta.featureid).map(fea=>({id:fea.id,...fea.properties}))
  }
  meta.panos=res.data
  if(!res.data?.length){
    meta.panoxml='<krpano><image><sphere url="/krpano/empty-cube.png"/></image><!--arrow--></krpano>'
    meta.panos=[]
    alert('등록된 파노라마 이미지가 없습니다.')
  }
  if(meta.panos.length==1){
    meta.panoxml=await fetch(config.backend+`panosinglexml/${meta.panos[0].id}/false/0/0`)
    meta.panoxml=await meta.panoxml.text()
    meta.panoxml=meta.panoxml.replaceAll('<!--mouseclickspot-->',krpanoxmls.mouseclickspot+krpanoxmls.stickmouseaction)
  }else if(meta.panos.length>1){
    meta.panoxml=await fetch(config.backend+`panocomparexml/${meta.fid}/false/0/0`)
    meta.panoxml=await meta.panoxml.text()
    meta.panoxml=meta.panoxml.replaceAll('<!--mouseclickspot-->','<scene name="mousespotscene">'+krpanoxmls.mouseclickspot+krpanoxmls.stickmouseaction+'</scene>')
    const xml=strToXml(meta.panoxml)
    let subkrpano_onloaded=xml.querySelector('[name="subkrpano_onloaded"]')
    subkrpano_onloaded.remove()
    subkrpano_onloaded=xml.createElement('action')
    subkrpano_onloaded.setAttribute('name','subkrpano_onloaded')
    subkrpano_onloaded.setAttribute('type','Javascript')
    //const func=function(){console.log("_st_")
    const jsBody=`
      var subkrpano = caller.krpano
      subkrpano.set('pakrpano',krpano)
      subkrpano.events.addListener("onnewpano",()=>krpano.actions.invalidatescreen())
      function subkrpano_loadscene(){
        var side = caller.name == "krpano1" ? 1 : 2
        subkrpano.set('name','subkrpano'+side)
        krpano.set('subkrpano'+side,subkrpano)
        var side_element = krpano.scene.getItem('scene'+caller.scene)
        krpano.set("layer[credit" + side +"].text", side_element.title)
        var arrow_content = krpano.scene.getItem('arrowscene')
        if(arrow_content){
          arrow_content=arrow_content.content
          arrow_content=arrow_content.replaceAll('_side_',side)
        }else arrow_content=''
        var mousespot_content = krpano.scene.getItem('mousespotscene').content
        subkrpano.actions.loadxml(('<krpano>' + side_element.content + arrow_content + mousespot_content + '</krpano>'), "view.limitview=off&view.fovmin=0", "MERGE", "BLEND(0.5)")
        var thumb = krpano["thumb" + side] = side_element["thumb" + side]
        krpano.call("layer[thumbs" + side +"].scrolltocenter(0," + (thumb.pixely + thumb.pixelheight/2) + ")")
      }
      krpano.addChangeListener(caller, "scene", subkrpano_loadscene)
      subkrpano_loadscene()`
    //console.log("_ed_")}
    //const jsBody = func.toString().split('console.log("_st_")')[1].split('console.log("_ed_")')[0];
    subkrpano_onloaded.textContent = ''
    subkrpano_onloaded.appendChild(xml.createCDATASection(jsBody))
    xml.documentElement.appendChild(subkrpano_onloaded)
    meta.panoxml=xmlToStr(xml)
    meta.panoxml=meta.panoxml.replace('console.log("thumb.onclick")','searchMemo(1)')
  }
  if(meta.sv.layertype=='LineString'){
    meta.links=[]
    for (const fea of [meta.feature, ...meta.merges]) {
      const pidx = fea.vertexidx - 1
      const nidx = fea.vertexidx + 1
      let filter = '<Filter><And><PropertyIsEqualTo><PropertyName>linefid</PropertyName><Literal>' + fea.linefid + '</Literal></PropertyIsEqualTo>'
        + '<Or><PropertyIsEqualTo><PropertyName>vertexidx</PropertyName><Literal>' + pidx + '</Literal></PropertyIsEqualTo>'
        + '<PropertyIsEqualTo><PropertyName>vertexidx</PropertyName><Literal>' + nidx + '</Literal></PropertyIsEqualTo></Or>'
        + '</And></Filter>'
      const res = await wfs({ layernm: meta.sv.gspointnm, filter: filter })
      res.features.map(fea=>({id:fea.id,...fea.properties})).forEach(fea=>meta.links.push(fea))
    }
    const frompos=[meta.feature.xpos,meta.feature.ypos]
    let arrowxml='<include url="/krpano/arrows.xml"/><layer name="connections">'
    meta.links.forEach(link=>{
      const linkpos=[link.xpos,link.ypos]
      let ang=bearing(frompos,linkpos)
      // ang+=meta.feature.hangle
      ang = (ang - meta.feature.hangle + 360) % 360
      arrowxml+=krpanoxmls.arrow
        .replaceAll("console.log('_arrowname_onover_')","krpano.pakrpano.call('toggle_layer('+krpano.name.replace('subkrpano','')+',true)')")
        .replaceAll("console.log('_arrowname_onout_')","krpano.pakrpano.call('toggle_layer('+krpano.name.replace('subkrpano','')+',false)')")
        .replaceAll("console.log('_arrowname_onclick_')",`tourl('${link.featureid}')`)
        .replaceAll('_arrowname_','arrow_'+link.featureid).replaceAll('_arrow_hdir_',ang+'')
    })
    arrowxml+='</layer>'
    if(meta.panos.length>1)arrowxml='<scene name="arrowscene">'+arrowxml+'</scene>'
    meta.panoxml=meta.panoxml.replaceAll('<!--arrow-->',arrowxml)
  }
  if(meta.sv.layertype=='NodeLink'){
    let filter='<Filter><Or><PropertyIsEqualTo><PropertyName>stfid</PropertyName><Literal>'+meta.fid+'</Literal></PropertyIsEqualTo>'
      +'<PropertyIsEqualTo><PropertyName>edfid</PropertyName><Literal>'+meta.fid+'</Literal></PropertyIsEqualTo>'
      +'</Or></Filter>'
    const res = await wfs({ layernm: meta.sv.gslinenm, filter: filter })
    const nodes=[]
    res.features?.forEach(linefeature=>{
      const coords=_.flattenDepth(linefeature.geometry.coordinates,1)
      const idx=coords.findIndex(coord=>equals(coord[0],meta.feature.xpos,5)&&equals(coord[1],meta.feature.ypos,5))
      if(idx==-1)return
      const taridx=idx==0?1:0
      const tarid=taridx==0?linefeature.properties.stfid:linefeature.properties.edfid
      let ang=bearing(coords[idx],coords[taridx])
      ang = (ang - meta.feature.hangle + 360) % 360
      nodes.push({fid:tarid,ang:ang})
    })
    let arrowxml='<include url="/krpano/arrows.xml"/><layer name="connections">'
    nodes.forEach(node=>arrowxml+=krpanoxmls.arrow
        .replaceAll("console.log('_arrowname_onover_')","krpano.pakrpano.call('toggle_layer('+krpano.name.replace('subkrpano','')+',true)')")
        .replaceAll("console.log('_arrowname_onout_')","krpano.pakrpano.call('toggle_layer('+krpano.name.replace('subkrpano','')+',false)')")
        .replaceAll("console.log('_arrowname_onclick_')",`tourl('${node.fid}')`)
        .replaceAll('_arrowname_','arrow_'+node.fid).replaceAll('_arrow_hdir_',node.ang+''))
    arrowxml+='</layer>'
    if(meta.panos.length>1)arrowxml='<scene name="arrowscene">'+arrowxml+'</scene>'
    meta.panoxml=meta.panoxml.replaceAll('<!--arrow-->',arrowxml)
  }
  meta.panoxml=meta.panoxml.replaceAll('"/krpano',`"${config.backend}krpano`).replaceAll('"/panofile',`"${config.backend}panofile`)
  meta.baserad=degToRad(meta.feature.hangle)
  const osmTile=new TileLayer({source:new OSM(),visible:false})
  const googleBaseTile=new TileLayer({source:new XYZ({url:'http://mt{0-3}.google.com/vt/lyrs=m&hl=ko&x={x}&y={y}&z={z}'})})
  const googleSateTile=new TileLayer({source:new XYZ({url:'http://mt{0-3}.google.com/vt/lyrs=y&hl=ko&x={x}&y={y}&z={z}'}),visible:false})
  const markerlayer=new VectorLayer({source:new VectorSource(),style:new Style({image: new Icon({anchorOrigin:'center-center',src:`${config.frontRoot}arrow-north.png`,rotation:meta.baserad})})})
  meta.map=new Map({target:'map',layers:[osmTile,googleBaseTile,googleSateTile,markerlayer],controls:defaultControls(),view:new View({zoom:meta.minimapzoom})})
  meta.osmTile=osmTile
  meta.googleBaseTile=googleBaseTile
  meta.googleSateTile=googleSateTile
  meta.markerlayer=markerlayer
  meta.pos=pos
  pos=fromLonLat(pos,meta.map.getView().getProjection())
  const feature=new Feature({geometry:new Point(pos)})
  meta.map.getView().fit(feature.getGeometry(),{minResolution:12})
  meta.markerlayer.getSource().addFeature(feature)
  res=await get('rest/authed/member/confs/vwapikey')
  if(!res.data.length)return
  meta.vwapikey=res.data[0].sval
  const pms={path:'req/address',service:'address',request:'getAddress',version:'2.0',crs:'EPSG:3857',type:'both',zipcode:'true',simple:'false',key: meta.vwapikey,point: pos}
  try{
    res=await vwapi('get',pms)
    if(res.response.result&&res.response.result.length>0){
      meta.addr=res.response.result[0].text
      meta.zipcode=res.response.result[0].zipcode
      meta.addrtype=res.response.result[0].type
    }
  }catch(e){
    console.log('vwapi error',e)
    alert('주소를 검색할 수 없습니다.')
  }
  initKrpano()
}
let isResizing = false
let startX = 0
let startY = 0
let startWidth = 0
let startHeight = 0
function onMouseDown(e) {
  isResizing = true
  startX = e.clientX
  startY = e.clientY
  const rect = popcard.value.$el.getBoundingClientRect()
  startWidth = rect.width
  startHeight = rect.height
  document.addEventListener('mousemove', onMouseMove)
  document.addEventListener('mouseup', onMouseUp)
}
function onMouseMove(e) {
  if (!isResizing) return
  const dx = e.clientX - startX
  const dy = e.clientY - startY
  let width=startWidth + dx;
  if(width>500)width=500
  let height=startHeight - dy;
  if(height>window.innerHeight-50)height=window.innerHeight-50
  popcard.value.$el.style.width = `${width}px`
  popcard.value.$el.style.height = `${height}px`
}
function onMouseUp() {
  isResizing = false
  document.removeEventListener('mousemove', onMouseMove)
  document.removeEventListener('mouseup', onMouseUp)
}
function winalert(msg) {
  window.alert(msg)
}
function open3d() {
  if(!meta.featurelink)winalert('준비중입니다.')
  else openWin(meta.featurelink)
}
window.tourl=fid=>{
  let current_mode='left_only'
  if(meta.krpano)current_mode=meta.krpano.get('current_mode')
  if(!current_mode)current_mode='left_only'
  if(props.reload)props.reload({svid:props.svid,fid,hlookat:meta.hlookat,vlookat:meta.vlookat,initmode:current_mode})
  else location.href=`${config.frontRoot}member/sv/${fid}/${meta.hlookat}/${meta.vlookat}/${current_mode}`
}
if(props.fid){
  meta.fid=props.fid
  if(props.hlookat)meta.hlookat=props.hlookat
  if(props.vlookat)meta.vlookat=props.vlookat
  if(props.initmode)meta.initmode=props.initmode
  if(props.minimapzoom)meta.minimapzoom=props.minimapzoom
}else{
  if(route.params.fid)meta.fid=route.params.fid
  if(route.params.hlookat)meta.hlookat=route.params.hlookat
  if(route.params.vlookat)meta.vlookat=route.params.vlookat
  if(route.params.initmode)meta.initmode=route.params.initmode
}
onMounted(()=>{
  init()
  resizehandle.value.addEventListener('mousedown', onMouseDown)
  window.clickAddMemo=clickAddMemo
  window.panoClick=panoClick
  window.searchMemo=searchMemo
  window.delMemoImg=delMemoImg
  get('rest/authed/member/featurelink/streetview/'+meta.fid,res=>{
    if(!res.data.id)return
    meta.featurelink=res.data.url
  })
})
onBeforeUnmount(() => {
  if (resizehandle.value) {
    resizehandle.value.removeEventListener('mousedown', onMouseDown)
  }
  delete window.clickAddMemo
  delete window.panoClick
  if(meta.krpano)meta.krpano.unload()
})
</script>
<template>
<div id="svwrap">
  <div ref="krpanocontainer" id="krpanocontainer"></div>
  <div id="popwrap" :class="meta.panos.length==0?'d-none':''">
    <v-card ref="popcard" id="pop" :class="meta.showpop?'':'d-none'">
        <!-- <v-icon ref="resizehandle" icon="mdi-resize" style="position: absolute;top: 0;right: 0;z-index: 10;cursor: nesw-resize;"/> -->
        <img ref="resizehandle" draggable="false" :src="config.frontRoot+'corner.png'" style="transform: rotate(-90deg);position: absolute;top: 0;right: 0;cursor: nesw-resize;" height="32"/>
        <v-card-title class="mt-2">
          <v-row>
            <v-col><v-btn block prepend-icon="mdi-map" :text="$t('map')" :color="meta.selpoptype=='map'?'primary':''" @click="clickPopBtn('map')"/></v-col>
            <v-col><v-btn block prepend-icon="mdi-radar" text="3D보기" @click="open3d"/></v-col>
          </v-row>
          <v-row>
            <v-col><v-btn block prepend-icon="mdi-note-multiple-outline" :color="meta.selpoptype=='notelist'?'primary':''" :text="$t('notelist')" @click="clickPopBtn('notelist')"/></v-col>
            <v-col><v-btn block prepend-icon="mdi-note-edit-outline" :color="meta.selpoptype=='takenotes'?'primary':''" :text="$t('takenotes')" @click="clickPopBtn('takenotes')"/></v-col>
          </v-row>
        </v-card-title>
        <v-card-text style="height: calc(100% - 40px);">
          <div id="map" class="w-100 h-100" :class="meta.selpoptype=='map'?'':'d-none'"></div>
          <div v-if="meta.memos" class="w-100 h-100" :class="meta.selpoptype!='map'?'':'d-none'">
            <v-row>
              <v-col><v-text-field hide-details variant="outlined" density="compact" :label="$t('enteryoursearchterm')" v-model="meta.memosearchval"/></v-col>
              <v-col><v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="searchMemo(1)"/></v-col>
            </v-row>
            <v-table fixed-header class="border-thin mt-2" height="260">
              <thead>
                <tr>
                  <th>{{ $t('registrationmodificationdate') }}</th>
                  <th>{{ $t('title') }}</th>
                  <th class="text-center">{{ $t('more') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="memo in meta.memos">
                  <td>{{ ymd(memo.mdt) }}</td>
                  <td>{{ memo.ttl }}</td>
                  <td class="text-center"><v-btn density="compact" :text="$t('more')" @click="memoDetailPop(memo.id)"/></td>
                </tr>
              </tbody>
            </v-table>
            <v-pagination density="compact" class="ma-auto" :length="meta.memos.pagettl" :total-visible="5" :model-value="meta.memos.currpage" @update:model-value="searchMemo"/>
          </div>
        </v-card-text>
      </v-card>
    <v-icon :icon="'mdi-chevron-'+(meta.showpop?'left':'right')" id="tglpop" @click="meta.showpop=!meta.showpop"/>
  </div>
</div>
<div class="memowrap position-absolute d-none">
  <v-card :title="$t('enteringnotes')">
    <v-card-text>
      <p>{{ $t('title') }}</p>
      <input class="w-100 border-thin memottl"/>
      <p>{{ $t('contents') }}</p>
      <textarea class="w-100 border-thin memocont" style="height: 180px;"/>
      <p>{{ $t('coordinates') }}</p>
      <v-row>
        <v-col><input class="w-100 border-thin memox" readonly/></v-col>
        <v-col><input class="w-100 border-thin memoy" readonly/></v-col>
      </v-row>
      <p>{{ $t('addressinformation') }}</p>
      <input class="w-100 border-thin memoaddr" readonly/>
      <p style="margin-bottom: 20px;">{{ $t('img') }}</p>
      <div class="d-none memoimgwrap" style="display: inline-block;position: relative;border: 1px solid black;">
        <img class="memoimg" style="max-width: 100%;max-height: 300px;"/>
        <img class="memoimgdel" :src="config.frontRoot+'close_circle.png'" width="32" style="position: absolute;top: -16px;right: -16px;cursor: pointer;"/>
      </div>
      <input type="file" class="upfile"/>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col><v-btn block variant="elevated" class="memocancel" :text="$t('cancel')"/></v-col>
        <v-col><v-btn block variant="elevated" color="error" class="memodel" :text="$t('delete')"/></v-col>
        <v-col><v-btn block variant="elevated" color="primary" class="memosave" :text="$t('save')"/></v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</div>
</template>
<style>
#svwrap #krpanocontainer{position: absolute;top: 0;left: 0;width: 100vw;height: 100vh;}
#svwrap #popwrap{position: absolute;bottom: 0px;left: 0px;z-index: 100;}
#svwrap #pop{width: 500px;height: 400px;position: relative;}
#svwrap #tglpop{position: absolute;bottom: 2px;left: 2px;width: 500px;height: 400px;}
#svwrap #tglpop{cursor: pointer;position: absolute;color:#fff;background-color: #3F51B5;width: 20px;height: 56px;bottom:0;left: 100%;z-index: 9;}
.memoinput{border: 1px solid #eee;}
</style>
